export default __webpack_public_path__ + "static/media/WeekCardHarbor2.6d785c7e.jpg";